const config = {}

const projConfig = Object.assign({}, window.projConfig.default)
if (process.env.NODE_ENV === 'production') {
  Object.assign(projConfig, window.projConfig.prod)
} else if (process.env.NODE_ENV === 'development') {
  Object.assign(projConfig, window.projConfig.dev)
}

// 接口地址
config.apiBaseUrl = projConfig.apiBaseUrl

// 文件接口
config.fileUrl = projConfig.basicFileUrl

// 接口超时
config.apiTimeout = projConfig.apiTimeout || 10000

// 上传接口超时
config.uploadTimeout = projConfig.uploadTimeout || 120000

export default config
